import React from 'react'
import useAdminRole from '../../hooks/useAdminRole'

export default function ConciergePreview() {
  const { role, loading: roleLoading } = useAdminRole()
  if (roleLoading) {
    return <p className="p-4 text-center text-muted">Loading...</p>
  }
  if (role !== 'technical_owner') {
    return <p className="p-4">Access Denied</p>
  }
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold mb-4">Concierge Service Preview</h1>
      <p className="mb-6">
        This is the preview of the Concierge Posting Service feature.
        All functionality is gated behind the <code>CONCIERGE_SERVICE</code> feature flag.
      </p>
      <p>Work in progress: implementation details and UI will appear here as development continues.</p>
    </div>
  )
}